<template>
  <div id="gasTempBarChart">
    <div id="chartBox" ref="gasTempBar"></div>
  </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
// 引入柱状图
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";
export default {
  name: "gasTempBarChart",
  data() {
    return {
      xaxisData: [],
      gasList: [],
    };
  },
  props: {
    xData: null,
    gasData: null,
  },
  watch: {
    xData: function (newData, oldData) {
      this.$set(this, "xaxisData", [...newData]);
      setTimeout(() => {
        this.myChart = echarts.init(this.$refs.gasTempBar);
        this.initData();
      }, 500);
    },
    gasData: function (newData, oldData) {
      this.$set(this, "gasList", [...newData]);
      setTimeout(() => {
        this.myChart = echarts.init(this.$refs.gasTempBar);
        this.initData();
      }, 500);
    },
  },
  created() {
    this.$set(this, "xaxisData", this.xData);
    this.$set(this, "gasList", this.gasData);
  },
  mounted() {
    setTimeout(() => {
      this.myChart = echarts.init(this.$refs.gasTempBar);
      this.initData();
    }, 500);
  },
  methods: {
    initData() {
      var option = {
        tooltip: {
          trigger: "axis",
        },
        textStyle: {
          color: "#E3EAF3",
        },
        grid: {
          top: "20%",
          left: "20%",
          right: "10%",
          bottom: "22%",
          containLabel: false,
        },
        xAxis: {
          type: "category",
          data: this.xaxisData,
          name: "时间(h)",
          nameLocation: "start",
          nameTextStyle: {
            fontSize: 10,
            fontWeight: 10,
            align: "center",
            verticalAlign: "top",
            padding: [8, 10, 0, 0],
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontSize: 10,
              fontWeight: 10,
            },
          },
        },
        yAxis: {
          type: "value",
          name: "气量(m³)",
          nameTextStyle: {
            fontSize: 10,
            fontWeight: 10,
            align: "left",
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontSize: 10,
              fontWeight: 10,
            },
          },
        },
        series: {
          type: "bar",
          name: "气量",
          barWidth: "10%",
          label: {
            show: true,
            position: "top",
          },
          itemStyle: {
            normal: {
              barBorderRadius: [4, 4, 0, 0],
              color: "#E4640F",
            },
          },
          data: this.gasList,
        },
      };
      this.myChart.setOption(option);
    },
  },
};
</script>
<style scoped>
#gasTempBarChart {
  width: 100%;
  height: 100%;
}
#chartBox {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/subComponents/smartGasTempBarChart.vue